<template>
  <div 
    class="collapsable-panel md-elevation-3 white bg"
    :class="{ collapsed: isCollapsed, expanded: !isCollapsed }"
  >  
    <div class="top-bar">
      <md-button v-if="isCollapsed && expandToLeft" class="md-icon-button md-dense first-page" @click="expand">
        <md-icon>first_page</md-icon>
      </md-button>
      <md-icon :md-src="icon" />
      <div v-if="!isCollapsed" class="md-title">
        {{ title }}
      </div>
      <div v-if="!isCollapsed" class="edit-buttons">
        <slot name="buttons" />
      </div>
      <md-button v-if="isCollapsed && expandToRight" class="md-icon-button md-dense last-page" @click="expand">
        <md-icon>last_page</md-icon>
      </md-button>
    </div>
    <div v-if="isCollapsed" class="collapsed-container">
      <div class="collapsed-content" :style="{ 'background-color': collapsedColor }" />
    </div>
    <md-content v-else class="scroll-content md-scrollbar">
      <slot />
    </md-content>    
  </div>
</template>

<script>
export default {
  name: 'collapsable-panel',
  props: {
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    expandToLeft: {
      type: Boolean,
      default: false,
    },
    expandToRight: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    collapsedColor: {
      type: String,
      default: '#f5f5f5',
    },
    showEditButtons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: {
        useCollapse: true,
      },
    };
  },
  computed: {
    isCollapsed() {
      return this.state.useCollapse && this.collapsed;
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateUseCollapse);
    this.updateUseCollapse();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateUseCollapse);
  },
  methods: {
    expand() {
      this.$emit('expand');
    },
    updateUseCollapse() {      
      const cw = document.documentElement.clientWidth;
      this.state.useCollapse = (cw < 2000);
    },
  }
}
</script>

<style scoped>
.collapsable-panel {
  border-radius: 5px;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid darkgray;
  padding: 10px;
}

.md-title {
  flex: 1;
  padding-left: 8px;
  height: 28px;
}

.copy-button {
  margin-right: 4px !important;
}

.md-button.md-icon-button {
  margin: 0;
  width: 28px;
  min-width: 28px;
  height: 28px;
}

.edit-buttons {
  display: flex;
}

.collapsed-container {
  height: calc(100% - 46px);
  padding: 1rem;
}

.collapsed-content {
  border-radius: 5px;
  height: 100%;
}

.scroll-content {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 56px);
  padding: 10px 10px 0 10px;
}

.expanded {
  flex: 1;
}

.collapsed {
  width: 100px;
}

@media (min-width: 2000px) {
  .collapsed {
    flex: 1;
  }
}
</style>